import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  private baseUrl: string = `${environment.legalAssureApiBaseUrl}`;
  private clientProfileNav: any = new BehaviorSubject<any>('default');
  castclientProfileNav = this.clientProfileNav.asObservable();

  constructor(private httpClient: HttpClient) { }

  createClient(request: any) {
    return this.httpClient.post<any[]>(this.baseUrl + 'Client', request);
  }

  getAllClients(): Observable<any[]> {
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any[]>(this.baseUrl + 'client', { headers: headersOptions });
  }

  getAllClientsByUser(user: string): Observable<any[]> {
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any[]>(this.baseUrl + `Client/GetClientDashboardDetailByUser/${user}`, { headers: headersOptions });
  }

  deleteById(data: any) {
    return this.httpClient.delete<any[]>(this.baseUrl + `client/${data}`);
  }
  getById(data: any) {
    return this.httpClient.get<any>(this.baseUrl + `client/${data}`);
  }
  updateClient(request: any) {
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put<any[]>(this.baseUrl + 'client', request);
  }

  addClientServices(request: any) {
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any[]>(this.baseUrl + `ClientService`, request);
  }

  getClientDashboardDetail(data: any) {
    return this.httpClient.get<any>(this.baseUrl + `ClientService/ClientServiceDashboardDetail/${data}`);
  }

  registerClientService(id: string, request: any) {
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any[]>(this.baseUrl + `ClientService`, request);
  }
  getAllClientServices(id: string) {
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any>(this.baseUrl + `ClientService/${id}`);
  }

  getClientServiceLog(serviceId: string) {
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any>(this.baseUrl + `ClientService/ClientServiceHistory/${serviceId}`);
  }

  updateClientServiceStatus(request: any) {
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put<any>(this.baseUrl + `ClientService/ClientServiceHistory`, request);
  }

  updateClientServiceWorkflowStatus(clientServiceId: string, status: 'Cancelled' | 'OnHold') {
    return this.httpClient.put<any>(
      this.baseUrl + `ClientService/UpdateClientServiceStatus/${clientServiceId}?status=${status}`,
      null
    );
  }

  updateClientServicePayment(request: any) {
    return this.httpClient.put<any>(this.baseUrl + `ClientService/UpdateClientServicePayment`, request);
  }


  shareClientDetail(data: any) {
    this.clientProfileNav.next(data);
  }

  updateOtherDescription(request: any) {
    return this.httpClient.post<any>(this.baseUrl + `client/updateOtherDescription`, request);
  }

  getClientServicePaymentHistory(id: string) {
    return this.httpClient.get<any>(this.baseUrl + `ClientService/GetClientSerivePaymentHistory/${id}`);
  }
  getClientServiceDetail(id: string, serviceId: string) {
    return this.httpClient.get<any>(this.baseUrl + `ClientService/${id}/${serviceId}`);
  }

  deleteClientService(id: any) {
    debugger;
    return this.httpClient.delete<any>(this.baseUrl + `ClientService/${id}`);
  }

  getCurrentMonth(id) {
    return this.httpClient.get<any>(this.baseUrl + `Client/GetClientDashboardCurrentMonthStatusCount/${id}`);

  }
  getLastSixMonth(id) {
    return this.httpClient.get<any>(this.baseUrl + `Client/GetClientDashboardLastSixMonthStatusCount/${id}`);

  }
  UpdatePaymentOrDiscount(request: any) {
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put<any>(this.baseUrl + `ClientService/UpdatePaymentOrDiscount`, request);
  }

  getAllClientsByManager(id: string): Observable<any[]> {
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any[]>(this.baseUrl + `Manager/${id}`, { headers: headersOptions });
  }

  getAllClientsDetails(): Observable<any[]> {
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any[]>(this.baseUrl + `Manager`, { headers: headersOptions });
  }

  getDailyReport(filterType: any, startDate: any, endDate: any) {
    if (filterType == 5) {
      return this.httpClient.get<any>(this.baseUrl + `Manager/DailyReport/${filterType}?startDate=${startDate}&endDate=${endDate}`);
    } else {
      return this.httpClient.get<any>(this.baseUrl + `Manager/DailyReport/${filterType}`);
    }
  }

  getDailyReportDetail(filterType: any, serviceGroup: string, startDate: any, endDate: any) {
    return this.httpClient.get<any>(this.baseUrl + `Manager/DailyReportDetail/${filterType}/${serviceGroup}?startDate=${startDate}&endDate=${endDate}`);
  }

  getOverAllStatusDetail() {
    return this.httpClient.get<any>(this.baseUrl + `Manager/OverallStatus`);
  }

  getClientServicesChargesByYear() {
    return this.httpClient.get<any>(this.baseUrl + `Manager/getClientServicesChargesByYear`);
  }

  getFinancialYearDetails() {
    return this.httpClient.get<any>(this.baseUrl + `Manager/getFinancialYearDetails`);
  }

  getClientServicesMonthlyChargesCurrentYear() {
    return this.httpClient.get<any>(this.baseUrl + `Manager/getClientServicesMonthlyChargesCurrentYear`);
  }
  getClientServicesDailyChargesCurrentMonth() {
    return this.httpClient.get<any>(this.baseUrl + `Manager/getClientServicesDailyChargesCurrentMonth`);
  }

  getClientServiceTaskByClientSericeId(id: string) {
    return this.httpClient.get<any>(this.baseUrl + `ClientService/GetClientSericeTaskByClientServiceId/${id}`);
  }

  createClientServiceTaskHistory(request: any) {
    return this.httpClient.post<any[]>(this.baseUrl + 'ClientService/CreateClientServiceTaskHistory', request);
  }

  getClientServiceTaskHistoryById(id: string) {
    return this.httpClient.get<any>(this.baseUrl + `ClientService/GetAllClientServiceTaskHistory/${id}`);
  }

  getDeliveryPointsGraph(id: string) {
    return this.httpClient.get<any>(this.baseUrl + `manager/getDeliveryPointsGraphByManager/${id}`);
  }

  getAllDeliveryPointsGraph(filterId: any, startDate: any, endDate: any) {

    if (filterId == 5) {
      return this.httpClient.get<any>(this.baseUrl + `manager/getAllDeliveryPointsGraph/${filterId}?startDate=${startDate}&endDate=${endDate}`);
    } else {
      return this.httpClient.get<any>(this.baseUrl + `manager/getAllDeliveryPointsGraph/${filterId}`);
    }
  }

  getAllDailyDeliveryPointsGraph(id: any, filter: string = 'Monthly') {
    return this.httpClient.get<any>(this.baseUrl + `manager/getDailyDeliveryPointsGraph/${id}/${filter}`);
  }

  getAllDailyDeliveryPointsGraphForManager() {
    return this.httpClient.get<any>(this.baseUrl + `manager/getAllDailyDeliveryPointsGraphForManager`);
  }
  getServiceGroupAnalytics(type:any) {
    return this.httpClient.get<any>(this.baseUrl + `manager/service-group-analystics/${type}`);
  }
  getServiceEnquiryServiceResult(type:any) {
    return this.httpClient.get<any>(this.baseUrl + `enquiry/getConvertedEnquiry/${type}`);
  }

  getAllBalancePaymentDetails() {
    return this.httpClient.get<any>(this.baseUrl + `manager/getAllBalancePaymentDetails`);
  }

  getAllPaymentHistory() {
    return this.httpClient.get<any>(this.baseUrl + `ClientService/GetAllPaymentHistory`);
  }

  getClientSummary(filter: number, startDate: any, endDate: any): Observable<any[]> {
    if (filter == 5) {
      let headersOptions = new HttpHeaders();
      headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
      return this.httpClient.get<any[]>(this.baseUrl + `Manager/ClientSummary/${filter}?startDate=${startDate}&endDate=${endDate}`, { headers: headersOptions });

    } else {
      let headersOptions = new HttpHeaders();
      headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
      return this.httpClient.get<any[]>(this.baseUrl + `Manager/ClientSummary/${filter}`, { headers: headersOptions });
    }
  }


   createServiceGroup(request: any) {
    return this.httpClient.post<any[]>(this.baseUrl + 'ServiceGroup', request);
  }
  updateServiceGroup(request: any) {
    return this.httpClient.put<any[]>(this.baseUrl + 'ServiceGroup', request);
  }
   getAllServiceGroup() {
    return this.httpClient.get<any>(this.baseUrl + `ServiceGroup`);
  }
  deleteServiceGroup(id: any) {
    debugger;
    return this.httpClient.delete<any>(this.baseUrl + `ServiceGroup/${id}`);
  }

  getServiceGroupById(id) {
    return this.httpClient.get<any>(this.baseUrl + `ServiceGroup/${id}`);

  }
  ScheduelRegistration(body:any){
    return this.httpClient.post(this.baseUrl +`ScheduleRegistration`,body);
  }
  getScheduelRegistrationDetails(body:any){
    return this.httpClient.get(this.baseUrl +`ScheduleRegistration/${body}`);
  }
  updateScheduelRegistration(body:any){
    return this.httpClient.put(this.baseUrl +`ScheduleRegistration`,body);
  }
  getScheduelRegistrationDetailsById(body:any){
    return this.httpClient.get(this.baseUrl +`ScheduleRegistration/get-by-id/${body}`);
  }
  deleteScheduleRegistration(id: any) {
    return this.httpClient.delete(this.baseUrl + `ScheduleRegistration/delete-schedule/${id}`);
  }
}
